import type { Ref, RefObject } from "react"

/**
 * Safely assigns a value to a React ref (function or object) TEMPORARY.
 */
export function setRef<T>(ref: Ref<T>, value: T | null): void {
  if (typeof ref === "function") {
    ref(value)
  } else if (ref !== null) {
    const mutableRef = ref as RefObject<T | null>
    mutableRef.current = value
  }
}
